import React from 'react';
import MaskedTextBox from './MaskedTextBox';
import * as consts from '../../constants';
export default p => {
  return (
    <div className="row">
      <div className={p.ext ? 'col-sm-8' : 'col-sm-12'}>
        <MaskedTextBox {...p} mask="000-000-0000" pattern={consts.REGEX_PHONENO} placeholder="__-__-____" />
      </div>
      {p.ext ?
        <div className="col-sm-4">
          <MaskedTextBox {...p} id={`${p.id}_ext`} name={`${p.name}_ext`} title="Extension" mask="00000" placeholder="_____" required={false} />
        </div>
        : null}
    </div>
  );
};